import { RigContractAmendmentBase } from './base/rig-contract-amendment-base';

export class RigContractAmendment extends RigContractAmendmentBase { }